export const useCountriesStore = defineStore('countries', {
  state: () => ({
    safeCountries: [],
  }),
  actions: {
    setSafeCountries(countries) {
      this.safeCountries = countries;
    },
  },
});
